import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var UIkit: any;

@Component({
  selector: 'app-choice-validation',
  templateUrl: './choice-validation.component.html',
  styleUrls: ['./choice-validation.component.scss']
})
export class ChoiceValidationComponent implements OnInit {

  @Input() name: string = '';
  @Output() changed = new EventEmitter();

  constructor() { }

  ngOnInit(): void {}

  sendResponse(choice): void {
    UIkit.modal(`#choice-validation-${this.name}`).hide();
    this.changed.emit(choice);
  }

}
